import gql from 'graphql-tag';

export default gql`
  mutation ImportZoomProgress($records: [ZoomProgressImportRecordInput!]!) {
    importZoomProgress(records: $records) {
      processed
      updated
      skipped
      errors {
        row
        studentId
        contentId
        message
      }
    }
  }
`;
